export const enum OtherSteps {
  Plan = 'Plan',
  Soap = 'SOAP',
  ScheduleAndGoals = 'Schedule & Goals',
}
